/**
 * SeloTransparencia component.
 * @module components/SeloTransparencia/SeloTransparencia
 */
import { Container } from '@plone/components';
import Image from '@plone/volto/components/theme/Image/Image';
import { useIntl, defineMessages } from 'react-intl';
import SeloTransparenciaImage from './selo.png';

const messages = defineMessages({
  seloAlt: {
    id: 'Selo do Programa Nacional de Transparência Pública',
    defaultMessage: 'Selo do Programa Nacional de Transparência Pública',
  },
  seloTitle: {
    id: 'Selo do Programa Nacional de Transparência Pública',
    defaultMessage: 'Selo do Programa Nacional de Transparência Pública',
  },
});

/**
 * SeloTransparencia component class.
 * @function SeloTransparencia
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const SeloTransparencia = () => {
  const intl = useIntl();
  return (
    <Container className="selo-wrapper">
      <Image
        className="selo-transparencia"
        src={SeloTransparenciaImage}
        width={80}
        height={80}
        alt={intl.formatMessage(messages.seloAlt)}
        title={intl.formatMessage(messages.seloTitle)}
      />
    </Container>
  );
};

export default SeloTransparencia;
